import { useFeature } from '@mafc/appshell';

const useCardIconsFeatureFlag = () => {
  return useFeature('payment_card_icons').value || {};
};

export default useCardIconsFeatureFlag;
